import { faCommentAltLines } from '@fortawesome/pro-light-svg-icons';
import classNames from 'classnames';

import { Leave } from '../types';
import { Interval } from 'components/types';

import { FontAwesomeSvgIcon } from 'components/shared';

import Absence from './Absence';

type Props = {
  absence: Leave;
  interval: Interval;
};

export default function LeaveAbsence({ absence, interval }: Props) {
  const { note, dutyHourType } = absence;
  const { colorCode: dhtColor = '#33ff99' } = dutyHourType;
  const isLeaveRequest = !absence.isApproved;

  return (
    <Absence
      absence={absence}
      className={classNames('absence', 'leave', {
        'is-leave-request': isLeaveRequest
      })}
      borderColor={dhtColor}
      interval={interval}
      background="white"
    >
      <>{note && <FontAwesomeSvgIcon icon={faCommentAltLines} />}</>
    </Absence>
  );
}
